import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import styles from '../styles/uikitLoadersLoading.module.scss';

const Loading = ({
  size = 32,
  ariaHidden = false,
  ariaLabel = 'loading',
  className = '',
  testId = '',
}) => (
  <div
    className={classnames(styles.element, className)}
    role="alert"
    aria-hidden={ariaHidden}
    aria-live="assertive"
    aria-label={ariaLabel}
    style={{ height: size, width: size }}
    data-testid={testId}
  />
);

Loading.propTypes = {
  size: PropTypes.number,
  className: PropTypes.string,
  ariaLabel: PropTypes.string,
  ariaHidden: PropTypes.bool,
  testId: PropTypes.string,
};

export { Loading as LoadingStorybook };
export default React.memo(Loading);
